const RE_PREFIX_PATTERN = /^re\s*:/i;
const SUBJECT_MAX_LENGTH = 500;

export const deriveReplySubject = (
  parentSubject: string | null | undefined
): string => {
  const base = (parentSubject ?? "").trim();
  const prefixed = RE_PREFIX_PATTERN.test(base) ? base : `Re: ${base}`;
  return prefixed.substring(0, SUBJECT_MAX_LENGTH);
};
